import config from "../../config/config";

const getBaseDomain = (host) => {
  const parts = (host || '').split('.').filter(Boolean);
  return parts.length >= 2 ? parts.slice(-2).join('.') : host || '';
};

// napravi dinamički URL za Raccoon Rush uz zadržavanje protokola i PORTA iz configa

export const makeDinamicServerUrl = (configuredUrl) => {
  try {
    const u = new URL(configuredUrl);
    const baseDomain = getBaseDomain(window.location.hostname); // npr. "nvsmy22pj8.click"
    if (!baseDomain) return configuredUrl;

    u.hostname = `${config?.default?.gameServers}.${baseDomain}`;
    return `${u.protocol}//${u.hostname}${u.port ? `:${u.port}` : ''}`;
  } catch {
    return configuredUrl;
  }
};